import styled from "styled-components/macro";
import {device} from "../../device";

export const StyledMainContainer = styled.div`
  width: 100%;
`;

export const StyledInnerContainer = styled.div`
  width: 100%;

  margin: auto;
  padding: 5px;
  max-width: 1200px;
  
  @media ${device.tablet} {
    padding: .5rem;
    overflow-x: hidden;
  }
`;
